export default __webpack_public_path__ + "static/media/morricana_map.85cd5b20.webp";